export interface IChannel {
    name: string;
    tvChannelItems?: IChannelItem[];
}

export interface IChannelItem {
    id: string;
    name: string;
    shortDescription: string;
    longDescription: string;
    tvChannelIcons: IChannelIcon[];
    points: number;
}

export interface IChannelIcon {
    name: string;
    url: string;
}

export interface IChannelPackage extends IChannel {
    icons: IPackageChannelIcon[];
    description: string;
    points: number;
}

export interface IPackageChannelIcon {
    name: string;
    iconUrl: string;
}

export function fetchChannels(countryCode: string): Promise<IChannel[]> {
    const url = "/api/tv/contentpkg/country?countryCode=" + countryCode;
    return fetch(url)
        .then((res) => res.json());
}
